import * as $ from 'jquery';

/**
 * ScrollPositionController
 *
 * @author Johannes Sommer <j.sommer@andersundsehr.com>
 */
export default class ScrollPositionController {
  private $header = $('.js-header');
  private $navigationContainer = $('.js-navigationContainer');
  private $mainSelector = $('.js-main');
  private $navigationProductSubmenuContainer = $('.js-navigationProductSubmenuContainer');
  private $navigationProductSubmenu = $('.js-navigationProductSubmenu');

  private navigationContainerDistance = 0;
  private navigationProductSubmenuDistance = 100;
  private mobileNavProductSubmenuDistance = 100;

  /**
   * Public function to init class
   */
  constructor() {
    this.addScrollWatcher();
    this.addMenuToTop();
  }

  /**
   * Scroll Watcher
   */
  addScrollWatcher() {
    $(window).on('scroll', () => {
      this.addMenuToTop();
    });
  }

  /**
   * stick mainNav to top
   */
  addMenuToTop() {
    const scrollTop = $(window).scrollTop();
    if (this.$navigationProductSubmenu.length) {
      if (scrollTop && scrollTop > this.navigationProductSubmenuDistance) {
        this.$navigationProductSubmenuContainer.addClass('fixProductSubmenuNavigation');
        this.$header.addClass('header--fixMobileHeaderNav');
        this.$mainSelector.addClass('main--fixedNavigation');
      } else if (scrollTop && scrollTop > this.mobileNavProductSubmenuDistance) {
        this.$header.addClass('header--fixMobileHeaderNav');
      } else {
        this.$navigationProductSubmenuContainer.removeClass('fixProductSubmenuNavigation');
        this.$header.removeClass('header--fixMobileHeaderNav');
        this.$mainSelector.removeClass('main--fixedNavigation');
      }
    } else if (scrollTop && scrollTop > this.navigationContainerDistance) {
      this.$navigationContainer.addClass('fixNavigation');
    } else {
      this.$navigationContainer.removeClass('fixNavigation');
    }
  }
}
